/**
 *
 * @module priceOrderRequest
 *
 */

import Check from 'check-types';
import OrderCampaign from './orderCampaign';
import PriceOrderRequestAddress from './priceOrderRequestAddress';

import InvalidArgumentException from './../exception/invalidArgumentException';

const {
    number,
    instanceStrict,
    array
} = Check.assert;

/**
 *
 * @class PriceOrderRequest
 *
 */
export default class PriceOrderRequest {

    /**
     *
     * @param {Array<String>} productIdentifiers
     * @param {Number} identifierType
     * @param {OrderCampaign} orderCampaign
     * @param {PriceOrderRequestAddress} address
     * @throws {InvalidArgumentException}
     *
     */
    constructor(productIdentifiers, identifierType, orderCampaign, address) {

        const errorMessage = {
            ctor: 'PriceOrderRequest(productIdentifiers, identifierType, orderCampaign, address)',
            get productIdentifiers() {
                return `${this.ctor} productIdentifiers should be an Array of Strings with length`;
            },
            get identifierType() {
                return `${this.ctor} identifierType should be a Number`;
            },
            get orderCampaign() {
                return `${this.ctor} needs SDK.Services.Commerce.OrderCampaign instance`;
            },
            get priceOrderRequestAddress() {
                return `${this.ctor} needs SDK.Services.Commerce.PriceOrderRequestAddress instance`;
            }
        };

        array.of.nonEmptyString(productIdentifiers, errorMessage.productIdentifiers, InvalidArgumentException);
        number(identifierType, errorMessage.identifierType, InvalidArgumentException);

        instanceStrict(
            orderCampaign,
            OrderCampaign,
            errorMessage.orderCampaign,
            InvalidArgumentException
        );

        instanceStrict(
            address,
            PriceOrderRequestAddress,
            errorMessage.priceOrderRequestAddress,
            InvalidArgumentException
        );

        /**
         *
         * @access public
         * @type {Array}
         *
         */
        this.productIdentifiers = productIdentifiers;

        /**
         *
         * @access public
         * @type {Number}
         *
         */
        this.identifierType = identifierType;

        /**
         *
         * @access public
         * @type {String}
         *
         */
        this.campaignCode = orderCampaign.campaignCode;

        /**
         *
         * @access public
         * @type {String}
         *
         */
        this.voucherCode = orderCampaign.voucherCode;

        /**
         *
         * @access public
         * @type {PriceOrderRequestAddress}
         *
         */
        this.address = address;

    }

}



// WEBPACK FOOTER //
// ./src/services/commerce/priceOrderRequest.js